<template>
  <div style="width:100%;min-width:840px;height:100%;background:#F9F9F9;padding-top:25px;">
    <v-card style="max-width:none;width:840px;min-height:100%;margin:0 auto;background:#ffffff;padding:65px 110px 80px 110px;">

      <create-title :title="title" @changeTitle="changeTitle"></create-title>

      <div style="width:100%;margin:0 auto;">
        <!--未上传视频-->
        <div v-if="uploadVideoState === 'noUpload'" style="display:flex;flex-direction: column;align-items: center;padding-top:70px;padding-bottom:110px;">
          <div style="position:relative;width:200px;height:150px;margin:0 auto;">
            <div style="width:100%;height:100%;border:1px dashed #a6a6a6;border-radius:2px;">
              <p style="font-size:30px;text-align:center;line-height:150px;color:#1976D2;" class="iconfontFamily">&#xe60b;</p>
            </div>
            <input ref="uploadVideoInput" @change="uploadVideo()" type="file" accept="audio/mp4, video/mp4, video/wmv, video/avi" style="position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:pointer;">
          </div>
          <p style="font-size:16px;color:#000000;" class="mt-1">拖入或点击上传视频</p>
          <p style="font-size:12px;color:#a6a6a6;" class="mt-3">支持格式avi、wmv、mp4，视频大小500M以内</p>
        </div>
        <!--已上传视频-->
        <div v-if="uploadVideoState === 'hasUpload'" style="position:relative;margin-top:25px;width: 100%;display: flex;border:1px solid #e5e5e5;">
          <video style="max-width:100%;max-height:465px;margin:0 auto;" controls>
            <source :src="videoSrc.replace('https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/','/huaweicloud')" type="video/mp4">
          </video>
          <div style="position:absolute;top:2px;right:2px;width:25px;height:25px;background:rgba(0, 0, 0, 0.5);border-radius:50%;text-align:center;">
            <v-icon @click="clearVideo" size="20" color="#ffffff" style="margin-bottom:1px;">
              mdi-close
            </v-icon>
          </div>
        </div>

      </div>

      <div style="width:100%;height:1px;background:#e5e5e5;"></div>
      <div class="mt-5">
        <create-cover-and-introduction :introduction="introduction" introductionNum="140" @changeIntroduction="changeIntroduction"
                                       :coverSrc="coverSrc" @editCoverOK="editCoverOK"></create-cover-and-introduction>
      </div>

      <div style="display:flex;" class="mt-6">
        <create-position :positionGeoName="geoName" :positionGeoJson="geoJson" @choosePositionOK="choosePositionOK" style="flex:1;"></create-position>
        <create-public-switch :publicStatus="publicStatus" @changePublicStatus="changePublicStatus" style="flex:1;padding-left:43px;"></create-public-switch>
      </div>

      <div class="footBar">
        <v-spacer></v-spacer>
        <v-btn @click="createVideoOK(0)" v-if="progressStatus === 0" height="30" color="#f5f5f5" style="margin-right:20px;">保存草稿</v-btn>
        <v-btn @click="createVideoOK(2)" height="30" dark color="#1E3A8A" style="margin-right:63px;">{{progressStatus === 0 ? "确定" : "重新提交"}}</v-btn>
        <v-snackbar v-model="snackbar_createSuccess" tile elevation="0" color="#4CAF50" width="840" height="30" timeout="1000" absolute class="createVideo_bottomSnackbar">{{snackbar_createSuccess_text}}</v-snackbar>
        <v-snackbar v-model="snackbar_createError" tile elevation="0" color="#CF0000" width="840" height="30" timeout="1000" absolute class="createVideo_bottomSnackbar">{{snackbar_createError_text}}</v-snackbar>

      </div>

      <!--loading弹窗-->
      <dialog-loading :dialog-show="showLoadingDialog"></dialog-loading>


    </v-card>
  </div>

</template>

<script>
import CreateTitle from '/src/components/create_page/CreateTitle';
import CreateCoverAndIntroduction from '/src/components/create_page/CreateCoverAndIntroduction';
import CreatePosition from '/src/components/create_page/CreatePosition';
import CreatePublicSwitch from '/src/components/create_page/CreatePublicSwitch';
import DialogLoading from '/src/components/loading/DialogLoading'
export default {
  name: "createVideo",
  components: {
    CreateTitle,CreateCoverAndIntroduction,CreatePosition,CreatePublicSwitch,DialogLoading
  },
  data(){
    return{
      infoId:"",
      title:"",
      coverSrc:"",
      introduction:"",
      geoName:"",
      geoJson:"",
      publicStatus:false,
      progressStatus:0,

      uploadVideoState:'noUpload',

      videoSrc:"",

      // footBarBottom:"0"

      snackbar_createSuccess:false,
      snackbar_createSuccess_text:"",
      snackbar_createError:false,
      snackbar_createError_text:"",

      showLoadingDialog:false,

    }

  },
  methods:{
    changeTitle(value){
      this.title = value;
    },
    choosePositionOK(param){
      this.geoName = param.city + " · " + param.name;
      this.geoJson = JSON.stringify({
        "type": "Point",
        "coordinates": [param.lng, param.lat]
      })
    },
    changeIntroduction(value){
      this.introduction = value;
    },
    editCoverOK(param){
      this.coverSrc = param;
    },
    changePublicStatus(param){
      this.publicStatus = param;
    },

    //上传视频
    uploadVideo(){
      let file = this.$refs.uploadVideoInput.files[0];

      if(file.type !== "audio/mp4" && file.type !== "video/mp4" && file.type !== "video/wmv" && file.type !== "video/avi"){
        this.$store.state.snackbarShow=true
        this.$store.state.snackbarText = "文件必须为以下格式：avi、wmv、mp4"
        this.$store.state.snackbarType = 'error'

        this.$refs.uploadVideoInput.value = '';
      }
      else if(file.size > 1024 * 1024 * 500){
        this.$store.state.snackbarShow=true
        this.$store.state.snackbarText = "文件大小不能超过500M"
        this.$store.state.snackbarType = 'error'
        this.$refs.uploadVideoInput.value = '';
      }
      else{
        //合法
        this.showLoadingDialog = true;
        let data = new FormData()
        data.append('multipartFile',file)
        data.append('userId','')
        this.$axios.post('/managerApi/upoladFile/uploadVideo',data)
            .then((resultData)=>{
              resultData = resultData.data;
              if(resultData.status === 200){
                this.videoSrc = resultData.data.picture;
                this.uploadVideoState = 'hasUpload';
                this.showLoadingDialog = false;
              }else{
                console.log(resultData.status + resultData.message);
                this.$refs.uploadVideoInput.value = '';
                this.uploadVideoState = 'noUpload';
                this.showLoadingDialog = false;
              }
            })
            .catch(()=>{
              this.$refs.uploadVideoInput.value = '';
              this.uploadVideoState = 'noUpload';
              this.showLoadingDialog = false;
            })
      }


    },
    //删除视频
    clearVideo(){
      this.videoSrc = "";
      this.uploadVideoState = 'noUpload';
    },




    //创建，保存草稿（新创建+编辑）
    createVideoOK(progressStatus){
      this.showLoadingDialog = true;
      let errorStatus = true;
      if(progressStatus === 2){
        //提交
        if(this.title === ""){
          this.snackbar_createError_text = "无法提交，请输入标题";
          this.snackbar_createError = true;
        }
        else if(this.title.length > 20){
          this.snackbar_createError_text = "标题长度不能超过20字";
          this.snackbar_createError = true;
        }
        else if(this.videoSrc === ""){
          this.snackbar_createError_text = "无法提交，请上传视频";
          this.snackbar_createError = true;
        }
        else if(this.coverSrc === ""){
          this.snackbar_createError_text = "无法提交，请选择封面";
          this.snackbar_createError = true;
        }
        else if(this.introduction === ""){
          this.snackbar_createError_text = "无法提交，请输入简介";
          this.snackbar_createError = true;
        }
        else if(this.introduction.length > 140){
          this.snackbar_createError_text = "简介长度不能超过140字";
          this.snackbar_createError = true;
        }
        else if(this.geoName === ""){
          this.snackbar_createError_text = "无法提交，请选择定位";
          this.snackbar_createError = true;
        }
        else{
          errorStatus = false;  //合法
        }
      }
      else if(progressStatus === 0){
        //草稿
        if(this.title === ""){
          this.snackbar_createError_text = "无法保存，请输入标题";
          this.snackbar_createError = true;
        }
        else if(this.title.length > 20){
          this.snackbar_createError_text = "标题长度不能超过20字";
          this.snackbar_createError = true;
        }
        else if(this.introduction === ""){
          this.snackbar_createError_text = "无法保存，请输入简介";
          this.snackbar_createError = true;
        }
        else if(this.introduction.length > 140){
          this.snackbar_createError_text = "简介长度不能超过140字";
          this.snackbar_createError = true;
        }
        else{
          errorStatus = false;  //合法
        }
      }

      if(!errorStatus){
        //合法
        let param = new FormData();
        param.append('mainType',3);
        param.append('mainTitle',this.title);
        param.append('bubblePicture',this.coverSrc);
        param.append('context',this.introduction);   //视频内容和简介相同
        param.append('thumbPicture',this.coverSrc);
        param.append('picture1',this.videoSrc);
        param.append('simpleInfo',this.introduction);
        param.append('geo',this.geoJson);
        param.append('geoName',this.geoName);
        param.append('publicStatus',this.publicStatus ? 1 : 0);
        param.append('progressStatus',progressStatus);
        if(this.infoId !== ""){
          param.append('infoId',this.infoId);
        }

        this.$axios({
          method:"post",
          url:"/authorApi/main-info/editMainInfo",
          data:param
        }).then((resultData)=>{
          resultData = resultData.data;
          if(resultData.status === 200){
            if(progressStatus === 0){
              //保存草稿
              this.infoId = resultData.data;
              this.snackbar_createSuccess_text = "保存成功，可在创作管理-草稿箱中进行查看"
              this.snackbar_createSuccess = true;
            }
            else if(progressStatus === 2){
              //创建
              this.snackbar_createSuccess_text = "提交成功，可在创作管理中进行查看详情"
              this.snackbar_createSuccess = true;
              setTimeout(()=>{
                this.$router.push({
                  path:'/home',query: {goHome:'goCreationManage'}
                })
              },2000)
            }
            this.showLoadingDialog = false;
          }
          else{
            this.showLoadingDialog = false;
            console.log(resultData.status + resultData.message);
          }
        }).catch((err)=>{
          this.showLoadingDialog = false;
          console.log(err);
        });
      }
      else{
        //非法
        this.showLoadingDialog = false;
      }





    },

    //进入编辑，获取原本信息
    getVideoInfo(){
      this.$axios({
        method:"get",
        url:"/authorApi/main-info/getMainInfoInfoId",
        params:{
          infoId:this.infoId,
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.title = resultData.data.mainTitle;
          this.coverSrc = resultData.data.bubblePicture;
          this.introduction = resultData.data.simpleInfo;

          if(resultData.data.geo !== ""){
            this.geoName = resultData.data.geoName;
            this.geoJson = resultData.data.geo;
          }


          this.publicStatus = resultData.data.publicStatus === 1 ? true : false;
          this.progressStatus = resultData.data.progressStatus;

          if(resultData.data.picture1 !== ""){
            this.videoSrc = resultData.data.picture1;
            this.uploadVideoState = 'hasUpload'
          }
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });
    }



  },
  mounted(){
    if(this.$route.query.creationId){
      this.infoId = this.$route.query.creationId;
      this.getVideoInfo();
    }

    //监听页面关闭
    window.onbeforeunload = function (e) {
      var message = '您是否确认离开此页面-您输入的数据可能不会被保存';
      e = e || window.event;
      if (e) {
        e.returnValue = message;
      }
      return "您是否确认离开此页面-您输入的数据可能不会被保存";
    }
  },
  beforeDestroy() {
    window.onbeforeunload = null
  },


}
</script>

<style scoped>
.footBar{
  position:fixed;
  left: 50%;
  bottom:0;
  transform: translate(-50%,0);
  width:100%;
  max-width:840px;
  height:70px;
  border-top:1px solid #f0f0f0;
  background:#ffffff;
  display:flex;
  align-items: center;
}
.createVideo_bottomSnackbar{
  bottom:70px;
}


</style>

<style>
.createVideo_bottomSnackbar .v-snack__wrapper{
  min-height:0;
  max-width:100%;
  margin:0;
}
.createVideo_bottomSnackbar .v-snack__content{
  padding:0;
  text-align:center;
}


.createVideo_topSnackbar .v-snack__wrapper{
  min-height:0;
  max-width:100%;
  margin:0;
  position:absolute;
  top:0;
}
.createVideo_topSnackbar .v-snack__content{
  padding:0;
  text-align:center;
}

</style>



